/* eslint-disable max-len */
import React, { useRef } from "react";
import Button from "../../common/components/Button/Button";
import Link from "../../common/components/Link/Link";
import { LinkTypes } from "../../common/components/Link/link-types";
import useIntersectionObserver from "../../common/hooks/useIntersectionObserver";
import useVisiblePage from "../../common/hooks/useVisiblePage";
import { Page } from "../../common/reducers/visible-page/visible-page-types";
import Title from "../../components/Title/Title";
var WhoAmI = function () {
    var ref = useRef(null);
    useVisiblePage(ref, Page.WHOAMI);
    var animationEntry = useIntersectionObserver(ref, {
        freezeOnceVisible: true,
    });
    return (React.createElement("div", { ref: ref, className: "whoami" },
        React.createElement("div", { className: "whoami__container" },
            React.createElement(Title, { title: "About me", subtitle: "~: whoami" }),
            React.createElement("p", null,
                "Hi! My name is ",
                React.createElement("b", null, "Sukrut"),
                ", I am an aspiring software engineer with interests in full stack development and hands-on design across the web."),
            React.createElement("p", null,
                "I am currently studying Computer Science at Wayne State University. Throughout this time, I've explored many of the facets of software engineering from the front end to the back end, but my goal has always been the same: to use ",
                React.createElement("b", null, "code"),
                " in order to bring",
                " ",
                React.createElement("b", null, "utility"),
                " to software. I'm always looking for new opportunities, so feel free to connect!"),
            React.createElement(Link, { href: "mailto:Sukrutnadigotti@gmail.com", type: LinkTypes.BUTTON },
                React.createElement(Button, { label: "Contact me!" }))),
        React.createElement("div", { className: "whoami__moving-border", "data-animate": animationEntry === null || animationEntry === void 0 ? void 0 : animationEntry.isIntersecting },
            React.createElement("div", { className: "whoami__concept whoami__concept--design" }, "Utility"),
            React.createElement("div", { className: "whoami__concept whoami__concept--coding" }, "Coding"))));
};
export default WhoAmI;
